import { getMessaging, getToken, type Messaging } from "firebase/messaging";
import { doc, setDoc } from "firebase/firestore";
import type { User } from "firebase/auth";
import { app, auth, db } from "../services/firebase";

// Messaging instance (typed)
export const messaging: Messaging = getMessaging(app);

/**
 * Save an FCM token to Firestore.
 * NOTE: this path will change when you migrate to Clubs.
 * For now it matches your legacy: Player/{userId}
 */
export async function saveTokenToFirestore(token: string, userId: string): Promise<void> {
  const userRef = doc(db, "Player", userId);
  await setDoc(userRef, { fcmToken: token }, { merge: true });
}

/**
 * Request notification permission, ensure the messaging SW is registered,
 * retrieve an FCM token, and save it for the authenticated user.
 */
export async function requestPermission(): Promise<void> {
  try {
    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
      console.error("Notification permission not granted");
      return;
    }

    // IMPORTANT:
    // If you're using Vite PWA plugin, sw.js is already controlled.
    // For FCM on the web you typically also need firebase-messaging-sw.js in /public.
    // We'll register it explicitly here, but it must exist and be valid JS.
    const swRegistration = await navigator.serviceWorker.register("/firebase-messaging-sw.js");

    const token = await getToken(messaging, {
      vapidKey: "BJ1syL_LZkDUHEDzeQQ1MCk3mxW-TgZVRV5750BCD0nBqtfy8C34Ea-JyTyrEf0OYrQYu-_UynwUkFzDeODBcHU", // keep your key
      serviceWorkerRegistration: swRegistration,
    });

    if (!token) {
      console.error("Failed to retrieve FCM token");
      return;
    }

    console.log("FCM token:", token);

    const user = auth.currentUser as User | null;
    if (user) {
      await saveTokenToFirestore(token, user.uid);
      console.log("FCM token saved for user:", user.uid);
    } else {
      console.warn("No authenticated user; token not saved");
    }
  } catch (error) {
    console.error("Error requesting notification permission or token:", error);
  }
}
